import { createBaseApi } from '../baseApi';

const api = createBaseApi('launchConfigConfigApi'); // Unique reducer path

export const enhancedLaunchConfigApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getLaunchConfig: builder.query({
            query: () => '/launch-config',
            // Keep unused data for a long time since this config rarely changes per session
            keepUnusedDataFor: 3600,
        }),
    }),
    overrideExisting: false,
});

export const { useGetLaunchConfigQuery } = enhancedLaunchConfigApi;
